import { Flex, Text } from '@chakra-ui/react';
import { ROLES } from 'store/types';

type TProps = {
    data: Array<ROLES>;
};

const getColors = (role: ROLES) => {
    const roles = {
        [ROLES.admin]: {
            color: 'gray.900',
            bgColor: 'gray.100',
        },
        [ROLES.member]: {
            color: 'gray.900',
            bgColor: 'gray.100',
        },
        [ROLES.customer]: {
            color: 'gray.900',
            bgColor: 'gray.100',
        },
        [ROLES.pending]: {
            color: 'yellow.700',
            bgColor: 'yellow.100',
        },
    };

    return roles[role];
};

const RoleCell = ({ data = [] }: TProps) => (
    <Flex gap="4px">
        {data.map(role => (
            <Flex
                key={role}
                borderRadius="4px"
                height="24px"
                alignItems="center"
                padding="0 8px"
                color={getColors(role).color}
                bgColor={getColors(role).bgColor}
            >
                <Text color="gray.900" fontSize="14px" fontWeight={500} textTransform="capitalize">
                    {role}
                </Text>
            </Flex>
        ))}
    </Flex>
);

export default RoleCell;
